import React from "react";
import Actions from "./BaseTable/Actions";
import ImageWithFallback from "@/components/ImageWithFallback";
import { booleanOptionIconLabels } from "@/constant/GeneralOptions/boolean";

const booleanOptionIconLabelMap = booleanOptionIconLabels();
export const columns = () => {
  return [
    {
      accessorKey: "actions",
      header: "Actions",
      enableResizing: false,
      enableSorting: false,
      cell: ({ row }) => <Actions row={row} />,
    },
    {
      accessorKey: "category.parent.name",
      header: "Category Group",
      cell: ({ row }) => <div>{row.original.category?.parent?.name}</div>,
    },
    {
      accessorKey: "category.name",
      header: "Category",
      cell: ({ row }) => <div>{row.original.category?.name}</div>,
    },
    {
      accessorKey: "level_rank",
      header: "Level Rank",
    },
    {
      accessorKey: "level_name",
      header: "Level Name",
    },
    {
      accessorKey: "requirements",
      header: "Requirements",
    },
    {
      accessorKey: "amount",
      header: "Amount",
    },
    {
      accessorKey: "multiple_badge",
      accessorFn: (row) => booleanOptionIconLabelMap[row.multiple_badge],
      header: "Multiple Badge?",
      cell: ({ getValue }) => <div className={"flex justify-center"}>{getValue()}</div>,
    },
    {
      accessorKey: "badge_url",
      header: "Badge",
      cell: ({ row }) => <ImageWithFallback url={row.getValue("badge_url")} />,
      enableResizing: false,
      enableSorting: false,
    },
    {
      accessorKey: "badge_tooltip",
      header: "Badge Tooltip",
    },
  ];
};

// $data = [
//     'id' => $this->id,
//     'category' => $this->category,
//     'level_rank' => $this->level_rank,
//     'level_name' => $this->level_name,
//     'requirements' => $this->requirements,
//     'amount' => $this->amount,
//     'multiple_badge' => $this->multiple_badge,
//     'badge_url' => $this->badge_url,
//     'badge_tooltip' => $this->badge_tooltip,
// ];
